'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.boolOrReturnValue = exports.drawBottomAxis = exports.drawTopAxis = undefined;

var _xAxis = require('../xAxis');

var _xAxis2 = _interopRequireDefault(_xAxis);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var drawAxis = function drawAxis(container, xScale, configuration, orientation, y) {
    return container.append('g').classed('x-axis', true).classed(orientation, true).attr('transform', 'translate(0, ' + y + ')').call((0, _xAxis2.default)(xScale, configuration, orientation));
};

var drawTopAxis = exports.drawTopAxis = function drawTopAxis(container, xScale, configuration, dimensions) {
    return drawAxis(container, xScale, configuration, 'top', 0);
};

var drawBottomAxis = exports.drawBottomAxis = function drawBottomAxis(container, xScale, configuration, dimensions) {
    return drawAxis(container, xScale, configuration, 'bottom', +dimensions.height - 21);
};

var boolOrReturnValue = exports.boolOrReturnValue = function boolOrReturnValue(x, data) {
    return typeof x === 'function' ? x(data) : x;
};
//# sourceMappingURL=xAxis.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/ansyn-event-drops/dist-es5/drawer/xAxis.js
// module id = ../../../../ansyn-event-drops/dist-es5/drawer/xAxis.js
// module chunks = vendor